<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        

        <div class="">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10 pt-4">
              <div class="row headercontenido">
                <div class="col-12">
                  <span class="titulo bold">Nuevo Usuario</span>
                </div>

              
              </div>

              <div class="contenido">
                <form class="row mx-3" method="post" @submit="submitFormulario($event)">
                  <div
                    class="formulario col-12 bg-white shadow p-4 rounded card"
                  >
                    <div class="row">

                      <!-- <div class="col-md-12 bgblanco rounded pb-4" v-if="this.$store.state.user.id == 1">
                        <div class="pb-3">
                          <label>
                           <select v-model="form.user_level" required>
                             <option value="">Perfil</option>
                             <option value="1">Administrador</option>
                             <option value="10">Básico</option>
                           </select>
                          </label>
                        </div>
                      </div> -->


                      <div class="col-md-12 bgblanco rounded pb-4" v-if="form.user_level == 1 && this.$store.state.user.id == 1">
                        <div class="pb-3">
                          <span>Ingresa el nombre del nuevo Contratante/Retailer</span>
                          <label>
                           <input type="text" v-model="form.contratante" maxlength="250" required>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12 bgblanco rounded pb-4" v-if="form.user_level == 10 && this.$store.state.user.id == 1">
                        <div class="pb-3">
                          <label>
                            <span>Selecciona un Contratante</span>
                           <select v-model="form.user_id" required>
                             <option value="">Contratante</option>
                             
                             <option :value="contratante.id" v-for="contratante in contratantes" :key="contratante.id">{{contratante.contratante}}</option>
                             
                           </select>
                          </label>
                        </div>
                      </div>


                      <div class="col-md-4 bgblanco rounded pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Nombre(s)</span>
                            <input
                              type="text"
                              v-model="form.nombre"
                              maxlength="100"
                              placeholder="Nombre(s)"
                              required
                            />
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4 bgblanco rounded pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Apellido Paterno</span>
                            <input
                              type="text"
                              v-model="form.apellido_paterno"
                              maxlength="100"
                              placeholder="Apellido Paterno"
                              required
                            />
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4 bgblanco rounded pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Apellido Materno</span>
                            <input
                              type="text"
                              v-model="form.apellido_materno"
                              maxlength="100"
                              placeholder="Apellido Materno"
                              required
                            />
                          </label>
                        </div>
                      </div>



                      <div class="col-md-4 bgblanco rounded pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Correo Electrónico</span>
                            <input
                              type="email"
                              v-model="form.email"
                              maxlength="100"
                              placeholder="Correo Electrónico"
                              required
                            />
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4 bgblanco rounded pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Verifica Correo Electrónico</span>
                            <input
                              type="email"
                              v-model="form.email2"
                              maxlength="100"
                              placeholder="Verifica Correo Electrónico"
                              required
                            />
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4 bgblanco rounded pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Teléfono</span>
                            <input
                              type="text"
                              v-model="form.telefono"
                              maxlength="100"
                              placeholder="+52"
                              required
                            />
                          </label>
                        </div>
                      </div>


                      <div class="col-md-6 bgblanco rounded pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Contraseña</span>
                            <input
                              type="password"
                              v-model="form.pwd"
                              maxlength="100"
                              placeholder="Contraseña"
                              required
                            />
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 bgblanco rounded pb-4">
                        <div class="pb-3">
                          <label>
                            <span>Verifica Contraseña</span>
                            <input
                              type="password"
                              v-model="form.pwd2"
                              maxlength="100"
                              placeholder="Verifica Contraseña"
                              required
                            />
                          </label>
                        </div>
                      </div>

                      <div class="col-md-12 bgblanco rounded pb-4">
                        <div class="pb-3">
                          <label>
                            
                            <input
                              type="checkbox"
                              v-model="form.envio"
                              maxlength="100"
                              placeholder=""

                            />
                            <span>
                              Enviar al usuario nuevo un correo electrónico con información sobre su cuenta.
                            </span>
                          </label>
                        </div>
                      </div>


                      



                    </div>

                   

                    <div class="row">
                      <div class="col-12">
                        <div
                          class="text-center pt-2 float-right"
                        >
                          <button
                            type="submit"
                            
                            class="submit btnnaranja"
                          >
                            FINALIZAR
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import moment from "moment";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      paso: 1,
      form: {
        contratante: "",
        user_id: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        email: "",
        email2: "",
        telefono: "",
        pwd: "",
        pwd2: "",
        envio: true,
        user_level: "1"
      },
      tiposervicio: "",
      columns: [
        "nombre",
        "email",
        "no_poliza",
        "no_certificado",
        "uri",
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Matrícula",
          nombre: "Nombre",
          email: "Email",
          no_poliza: "No. de póliza",
          no_certificado: "No. de certificado",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar registro",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
      estados: [],
      municipios: [],
      colonias: [],
      contratantes: [],
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
    AOS.init();

    //this.consultaEstados();
    this.consulta();

    console.log({user: this.$store.state.user})
  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {};

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log({qData: JSON.stringify(qData)});

      this.$http
        .post(
          vm.$store.state.baseurl + "consulta-contratantes.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.contratantes = res.datos;
              

            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    consultaEstados(){

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {};

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-estados.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.estados = res.datos;
              console.log({estados: this.estados})
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );

    },
    estadoChange(e){


      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-municipios.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.municipios = res.datos;
              this.form.municipio_o_del = "";
              this.form.colonia = "";
              this.form.cp = "";
              console.log({mnpios: this.municipios})
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );


    },
    municipioChange(e){


      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado,
        c_mnpio: this.form.municipio_o_del
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-colonias.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.colonias = res.datos;
              this.form.colonia = "";
              this.form.cp = "";
              console.log({colonias: this.colonias})
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );


    },
    coloniaChange(e){


      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        c_estado: this.form.estado,
        c_mnpio: this.form.municipio_o_del,
        id_asenta_cpcons: this.form.colonia
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-cp.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.form.cp = res.datos[0].d_codigo;
              console.log({cp: this.form.cp })
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
          }
        );


    },
    razonSocialChange(e) {
      if (!this.form.usar_razon_social) {
        this.form.razon_social = "";
      } else {
        this.form.rfc = "";
        this.form.nombre = "";
        this.form.apellido_paterno = "";
        this.form.apellido_materno = "";
      }
    },
    continuar() {
      if (this.validaPaso(this.paso) == false) {
        swal.fire(
          "Datos faltantes",
          "Por favor llena todos los campos del formulario antes de continuar.",
          "warning"
        );
        return;
      }

      this.paso++;

      if (this.paso == 5) {
        //calcular prima, iva, etc
        let valor_factura = this.form.valor_factura;
        let prima_neta = 0;
        if (valor_factura > 0) {
          //calcular prima neta
          if (valor_factura <= 50000) {
            this.form.prima_neta = 862.06;
          } else if (valor_factura <= 100000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.052).toFixed(2);
          } else if (valor_factura <= 300000) {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315).toFixed(
              2
            );
          } else {
            this.form.prima_neta = parseFloat(valor_factura * 0.0315).toFixed(
              2
            );
          }

          //calcular derechos de poliza
          if (this.form.prima_neta <= 1000) {
            this.form.derecho_de_poliza = 125.0;
          } else if (this.form.prima_neta <= 5000) {
            this.form.derecho_de_poliza = 250.0;
          } else if (this.form.prima_neta <= 10000) {
            this.form.derecho_de_poliza = 325.0;
          } else if (this.form.prima_neta <= 30000) {
            this.form.derecho_de_poliza = 500.0;
          } else {
            this.form.derecho_de_poliza = 700.0;
          }

          //calcular iva
          this.form.iva = parseFloat(
            (parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza)) *
              0.16
          ).toFixed(2);
          this.form.prima_total = parseFloat(
            parseFloat(this.form.prima_neta) +
              parseInt(this.form.derecho_de_poliza) +
              parseFloat(this.form.iva)
          ).toFixed(2);
        }
      }
    },
    regresar() {
      this.paso--;
    },
    validaPaso(paso) {
      var flag = false;

      if (paso == 1) {
        if (this.form.contratante != "") {
          flag = true;
        }
      } else if (paso == 2) {
        if (
          this.form.no_poliza != "" &&
          this.form.vigencia_ini != "" &&
          this.form.vigencia_fin != ""
        ) {
          flag = true;
        }
      } else if (paso == 3) {
        if (
          this.form.rfc != "" &&
          this.form.email != "" &&
          this.form.email2 != "" &&
          this.form.telefono != "" &&
          this.form.estado != "" &&
          this.form.municipio_o_del != "" &&
          this.form.colonia != "" &&
          this.form.cp != "" &&
          this.form.calle != "" &&
          this.form.no_ext != ""
        ) {
          flag = true;
        }

        if (this.form.usar_razon_social == true) {
          if (this.form.razon_social == "") {
            flag = false;
          }
        } else {
          if (
            this.form.nombre == "" ||
            this.form.apellido_paterno == "" ||
            this.form.apellido_materno == ""
          ) {
            flag = false;
          }
        }
      } else if (paso == 4) {
        if (
          this.form.descripcion != "" &&
          this.form.marca != "" &&
          this.form.modelo != "" &&
          this.form.no_serie != "" &&
          this.form.equipamiento_adicional != "" &&
          this.form.valor_factura != "" &&
          this.form.ano != ""
        ) {
          flag = true;
        }
      }

      return flag;
    },
    validaCamposVacios() {
      var flag = false;
      if (
        this.form.contratante != "" &&
        this.form.vigencia_ini != "" &&
        this.form.vigencia_fin != "" &&
        this.form.rfc != "" &&
        this.form.email != "" &&
        this.form.email2 != "" &&
        this.form.telefono != "" &&
        this.form.estado != "" &&
        this.form.municipio_o_del != "" &&
        this.form.colonia != "" &&
        this.form.cp != "" &&
        this.form.calle != "" &&
        this.form.no_ext != "" &&
        this.form.no_int != "" &&
        this.form.descripcion != "" &&
        this.form.marca != "" &&
        this.form.modelo != "" &&
        this.form.no_serie != "" &&
        this.form.equipamiento_adicional != "" &&
        this.form.valor_factura != "" &&
        this.form.ano != ""
      ) {
        flag = true;
      }

      if (this.form.usar_razon_social == true) {
        if (this.form.razon_social == "") {
          flag = false;
        }
      } else {
        if (
          this.form.nombre == "" ||
          this.form.apellido_paterno == "" ||
          this.form.apellido_materno == ""
        ) {
          flag = false;
        }
      }

      return flag;
    },
    submitFormulario(e) {
      //terminar
      e.preventDefault();

      
      if (this.form.email != this.form.email2) {
        swal.fire(
          "Nuevo usuario",
          "No coincide el campo de verificación de correo electrónico.",
          "warning"
        );
        return;
      }

      //revisar longitud, alfanumerico y mayúsculas
      if (!this.form.pwd.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{15,}$/)) {
        swal.fire(
          "Cambiar contraseña",
          "La contraseña debe de tener al menos 15 caracteres alfanúmericos, al menos 1 número y al menos una mayúscula. Ej. contraGAIG76483",
          "warning"
        );
        return;
      }

      if (this.form.pwd != this.form.pwd2) {
        swal.fire(
          "Nuevo usuario",
          "No coincide el campo de verificación de contraseña.",
          "warning"
        );
        return;
      }

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = this.form;

     

      //console.log(JSON.stringify(qData));
      let url = "";
      if(this.$store.state.user.id == 1){
        url = "alta-usuario-admin.php";
      }else{
        url = "alta-usuario.php";
        qData["admin_id"] = this.$store.state.user.admin_id;
      }

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));
      
      console.log({qData})

      this.$http
        .post(vm.$store.state.baseurl + url, formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");

              swal
                .fire({
                  title: "Registro",
                  html: res.msg,
                  confirmButtonText: `Ok`,
                  icon: "success",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    this.$router.push("/usuarios");
                  }
                });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    changeVigenciaIni() {
      console.log(this.form.vigencia_ini);
      let date = new Date(this.form.vigencia_ini);
      date.setFullYear(date.getFullYear() + 1);
      this.form.vigencia_fin =
        this.formatDate(date) + "T" + this.formatTime(date);

      //console.log(this.form.vigencia_fin);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes();

      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;

      return [hour, minute].join(":");
    },
  },
};
</script>

